import { render, staticRenderFns } from "./DisabledNeedsPlate.vue?vue&type=template&id=3d389d7c&scoped=true&"
import script from "./DisabledNeedsPlate.vue?vue&type=script&lang=js&"
export * from "./DisabledNeedsPlate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d389d7c",
  null
  
)

export default component.exports